import * as React from 'react';
import * as types from 'modules/types/smSupplierManagement';
// @ts-ignore
import _ from 'lodash';
import classnames from 'classnames';
import { Card, Form, Tag } from '@beehive/components';
import DotDotDot from '@mpc/common/src/components/DotDotDot';
import { BASIC_INFO_KEYS, TRANSLATE_MAPPING_KEYS, STATUS_COLORS_MAPPING } from '../utils';
import { getCurValue } from './ServiceInfo';
import { CustomFormKeys, HandleChagneParams, renderForm } from '../Edit/BasicInfo';
import PropTypes from 'prop-types';
import supplierMessages from 'messages/Models/Supplier';
import titleMessages from 'messages/CompanyManagement/CardTitle';

const messages = { ...supplierMessages, ...titleMessages };

export const BASE_INFO_KEYS = {
  short_name: {
    itemColProps: { sm: 12, xl: 7 },
  },
  supplier_type: {
    itemColProps: { sm: 12, xl: 9 },
  },
  region: {
    itemColProps: { sm: 12, xl: 8 },
  },
  parent_company: {
    itemColProps: { sm: 12, xl: 7 },
  },
  address: {
    itemColProps: { sm: 12, xl: 9 },
  },
  advance_payment: {
    itemColProps: { sm: 12, xl: 8 },
  },
  service_type: {
    itemColProps: { sm: 12, xl: 7 },
  },
  service_content: {
    itemColProps: { sm: 12, xl: 9 },
  },
};

export interface BaseInfoProps {
  data: types.SupplierMangementDetail;
  onChange?: any;
  customFormKeys?: CustomFormKeys;
}

export default class BaseInfo extends React.Component<BaseInfoProps, any> {
  public static defaultProps: Partial<BaseInfoProps> = {
    customFormKeys: BASE_INFO_KEYS,
  };

  public static contextTypes = {
    intl: PropTypes.object,
  };

  // 修改内容
  private handleChange = (params: HandleChagneParams) => {
    const { onChange, data } = this.props;
    const { key, value } = params;
    const error = _.get(data, `detailError.messages.${key}`);
    const newDetailError = _.cloneDeep(data.detailError);
    if (error) {
      delete newDetailError.messages[key];
    }
    const newData = {
      ...data,
      detailError: { ...newDetailError },
      [key]: value,
    };
    if (onChange) {
      onChange(newData);
    }
  }

  public render() {
    const { intl } = this.context;
    const { data, customFormKeys = {}, data: { saveClicked } } = this.props;
    const formKeys = Object.keys(customFormKeys);
    const errorMsg = _.pick(_.get(data, 'detailError.messages'), formKeys);
    // 比如新增推荐时有编辑项，表单用编辑模式
    const mode = formKeys.some((key: string) => !!customFormKeys[key].componentClass) ? 'edit' : 'show';
    const dirtyAttrs: any[] = _.get(data, 'dirty_attrs.supplier', []);
    return (
      <Card
        titleNode={intl.formatMessage(messages.basicInfo)}
        className="basic-info-show"
        loading={data.loading}
      >
        <div className="base-info-first-row">
          <span className="base-info-full_name">{data.full_name}</span>
          <Tag text={data.translated_status || ''} color={STATUS_COLORS_MAPPING[data.status || '']} />
          <span className="base-info-mpc_no">{data.mpc_no}</span>
        </div>
        <div className="base-info-items">
          <Form isLabelVertical errorMsg={errorMsg} showError={saveClicked} mode={mode}>
            {
              Object.keys(customFormKeys).map((key: string) => {
                const item = BASIC_INFO_KEYS[key];
                const customItem = customFormKeys[key];
                const value = getCurValue(data[TRANSLATE_MAPPING_KEYS[key]
                  ? TRANSLATE_MAPPING_KEYS[key].mapping_key : key]);
                return (
                  <Form.Item
                    label={item.label && intl.formatMessage(messages[item.label])}
                    key={key}
                    itemColProps={customItem.itemColProps}
                    required={!!customItem.required}
                    itemKey={key}
                    className={classnames(key, { ['color-red']: dirtyAttrs.includes(key) })}
                  >
                    {
                      customItem.componentClass ? (
                        renderForm({ key, value: data[key], data: customFormKeys, handleChange: this.handleChange })
                      ) : (
                          <span>
                            <DotDotDot clamp={'service_content' === key ? 3 : 1}>
                              {value}
                            </DotDotDot>
                          </span>
                        )
                    }
                  </Form.Item>
                );
              })
            }
          </Form>
        </div>
      </Card>
    );
  }
}
